module.exports = __webpack_public_path__ + "static/media/table.3c2f3669.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/table.png
// module id = 1062
// module chunks = 1